import type {ReactNode} from 'react';

interface TableToolbarProps {
  search: ReactNode;
  actions: ReactNode;
}

const TableToolbar = ({search, actions}: TableToolbarProps) => (
  <div className="mb-6 flex flex-wrap items-center gap-3">
    {search}
    <div className="ml-auto flex items-center gap-2">{actions}</div>
  </div>
);

export default TableToolbar;
